import React, { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Admin → Social tab: change the admin login email (kept across redeploys via settings.admin_email).
export default function AdminAccountCard() {
  const { user, refresh, formatApiError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) { toast.error("Enter the new email and your current password."); return; }
    setBusy(true);
    try {
      const { data } = await api.put("/admin/account/email", { new_email: email.trim(), password });
      toast.success(`Admin login is now ${data.email}`);
      setEmail(""); setPassword("");
      refresh?.();
    } catch (err) { toast.error(formatApiError ? formatApiError(err) : (err.response?.data?.detail || "Could not update email")); }
    finally { setBusy(false); }
  };

  const field = "w-full rounded-xl border border-[#19324A]/15 px-3 py-2 text-sm";
  return (
    <div className="bg-white rounded-3xl soft-shadow p-5 mt-6" data-testid="admin-account-card">
      <h3 className="font-display font-bold text-[#19324A] flex items-center gap-2"><KeyRound className="w-4 h-4 text-[#FF6B9D]" /> Admin login</h3>
      <p className="text-xs text-[#19324A]/55 mt-1">Signed in as <span className="font-semibold" data-testid="admin-current-email">{user?.email}</span>. Change the email you use to log in — your password stays the same.</p>
      <form onSubmit={submit} className="grid sm:grid-cols-[1fr_1fr_auto] gap-2 mt-3">
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="New admin email" className={field} data-testid="admin-email-input" />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Current password" className={field} data-testid="admin-email-password" />
        <button type="submit" disabled={busy} className="btn-primary !py-2 text-sm" data-testid="admin-email-save">{busy ? "Saving…" : "Update email"}</button>
      </form>
    </div>
  );
}
